import { createPortal } from "react-dom"
import "./Loader.css"
import { Spinner } from "@george-labs.com/design-system"

const Loader = () => {
  return createPortal(
    <div className="preloader-overlay g-bootstrap g-bs4">
      <div className="preloader-container">
        <Spinner size={Spinner.SIZE.LARGE} />
      </div>
    </div>,
    document.body,
  )
}

export default Loader
